import { render, staticRenderFns } from "./FormulacionPage.vue?vue&type=template&id=49aef6f2"
import script from "./FormulacionPage.js?vue&type=script&lang=js&external"
export * from "./FormulacionPage.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports